import React,{useState, useEffect} from 'react';
import { HashRouter, Route, Switch, Redirect, BrowserRouter, Routes, Link, useNavigate} from "react-router-dom";
import styled from 'styled-components';

const Container = styled.div`
  font-size : ${({size}) =>size}px;
  color :${({color}) =>color};
  display:flex;
  justify-content:center;
  align-items:center;
  text-align : left;
  font-family:Pretendard-Bold;

`

const Text = ({containerStyle, value, size, color}) => {


  return (
    <Container style={containerStyle} size={size} color={color}>
      {value}
    </Container>
  );
}

Text.defaultProps = {
  color :"#000"
}

export default Text;
